import { render, staticRenderFns } from "./WorkspaceBrowser.vue?vue&type=template&id=db1237fa&scoped=true&"
import script from "./WorkspaceBrowser.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceBrowser.vue?vue&type=style&index=0&id=db1237fa&scoped=true&lang=scss&"
import style1 from "./WorkspaceBrowser.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1237fa",
  null
  
)

export default component.exports